import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoadingComponent } from './navigation/loading/loading.component';
import { LoginResolverService } from './login/services/login-clear.services';
import { LoginComponent } from './login/login-component/login.component';

const routes: Routes = [
    {
        path: 'Login',
        component: LoginComponent,
        resolve: { login: LoginResolverService },
    },
    { path: '**', component: LoadingComponent, data: { dynamic: true } },
    { path: 'Loading', component: LoadingComponent },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { useHash: true, enableTracing: false }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
